/* Hero: un solo trazo a velocidad constante (540px/s). El horizontal carga,
   dobla, baja el canal; el texto lo destapa la misma cabeza (registro por
   recorte en el envoltorio + deslizamiento de 12px en el hijo). Al cerrar el
   ultimo bloque se avisa a la franja (eq:heroListo). Ademas, la batea. */
const { mount, reduced, SPEED, fontsReady, yaVisto, marcarVisto } = window.EQ;

mount('[data-eq-hero]', (root) => {
  const seg = (k) => root.querySelector('[data-eq-path="' + k + '"]');
  const top = root.querySelector('[data-eq-anchor="top"]');
  const bot = root.querySelector('[data-eq-anchor="bottom"]');
  let tailPct = 0, typed = false, ruleTimer = 0, typeGuard = 0, heroAviso = 0, ro = null;
  const capCanvas = document.createElement('canvas');

  // distancia del borde de la caja de linea a la altura de mayuscula real
  const capOffset = (el) => {
    try {
      const cs = getComputedStyle(el);
      const px = parseFloat(cs.fontSize) || 0;
      const ctx = capCanvas.getContext('2d');
      ctx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      const m = ctx.measureText('H');
      const asc = m.fontBoundingBoxAscent, desc = m.fontBoundingBoxDescent, capAsc = m.actualBoundingBoxAscent;
      if (!asc || !capAsc) return 0;
      const lh = parseFloat(cs.lineHeight) || px;
      const halfLeading = (lh - (asc + desc)) / 2;
      return Math.max(0, halfLeading + (asc - capAsc));
    } catch (e) { return 0; }
  };

  // el trazo mide el bloque de texto: dobla en la altura de mayuscula de la H1
  // y termina en el pie del boton
  const placePath = () => {
    const a = seg('h'), b = seg('v');
    if (!a || !b || !top || !bot || !a.offsetParent) return;
    const rs = a.offsetParent.getBoundingClientRect();
    const rt = top.getBoundingClientRect(), rbb = bot.getBoundingClientRect();
    const y = 22;
    const hgt = Math.round(rbb.bottom - rs.top - y);
    a.style.top = y + 'px';
    b.style.top = y + 'px';
    b.style.bottom = 'auto';
    b.style.height = hgt + 'px';
    const capY = rt.top - rs.top + capOffset(top);
    tailPct = Math.max(0, Math.min(60, (capY - y) / hgt * 100));
  };

  const settleType = () => {
    root.querySelectorAll('[data-eq-reg]').forEach((el) => {
      el.style.clipPath = 'none';
      if (el.firstElementChild) el.firstElementChild.style.transform = 'none';
    });
  };

  const registerBlocks = (rs, t1) => {
    typed = true;
    const SLIDE = 12;
    const v = seg('v');
    const vr = v ? v.getBoundingClientRect() : null;
    let fin = 0;
    root.querySelectorAll('[data-eq-reg]').forEach((el) => {
      const r = el.getBoundingClientRect();
      const y = el.getAttribute('data-eq-axis') === 'y';
      const from = y ? (vr ? r.top - vr.top : 0) : r.left - rs.left;
      const len = y ? r.height : r.width;
      const delay = (y ? t1 : 0) + Math.max(0, from) / SPEED * 1000;
      const dur = Math.max(1, len / SPEED * 1000);
      const out = y ? 'inset(0 0 100% 0)' : 'inset(0 100% 0 0)';
      el.animate([{ clipPath: out }, { clipPath: 'inset(0 0 0 0)' }], { duration: dur, delay, easing: 'linear', fill: 'forwards' });
      const kid = el.firstElementChild;
      if (kid) kid.animate([
        { transform: y ? 'translateY(-' + SLIDE + 'px)' : 'translateX(-' + SLIDE + 'px)' },
        { transform: 'none' }
      ], { duration: dur, delay, easing: 'linear', fill: 'forwards' });
      fin = Math.max(fin, delay + dur);
    });
    clearTimeout(heroAviso);
    heroAviso = setTimeout(() => window.dispatchEvent(new CustomEvent('eq:heroListo')), fin + 120);
  };

  const go = () => {
    marcarVisto('hero');
    placePath();
    const a = seg('h'), b = seg('v');
    if (!a || !b) return;
    const ra = a.getBoundingClientRect();
    const t1 = a.offsetWidth / SPEED * 1000;
    const tail = tailPct || 0;
    const t2 = b.offsetHeight / SPEED * 1000;
    const t3 = (tail / 100) * b.offsetHeight / SPEED * 1000;
    a.animate([
      { clipPath: 'inset(0 100% 0 0)' },
      { clipPath: 'inset(0 0 0 0)', offset: 0.5 },
      { clipPath: 'inset(0 0 0 100%)' }
    ], { duration: t1 * 2, easing: 'linear', fill: 'forwards' });
    b.animate([{ clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: t2, delay: t1, easing: 'linear', fill: 'forwards' });
    b.animate([{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(' + tail + '% 0 0 0)' }], { duration: t3, delay: t1 * 2, easing: 'linear', fill: 'forwards' });
    // la regla de la primera grilla arranca cuando la cabeza cruza su borde
    document.querySelectorAll('[data-eq-loadrule]').forEach((el) => {
      const r = el.getBoundingClientRect();
      el.style.transition = 'none';
      el.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], {
        duration: el.offsetWidth / SPEED * 1000,
        delay: Math.max(0, (r.left - ra.left) / SPEED * 1000),
        easing: 'linear', fill: 'forwards'
      });
    });
    registerBlocks(a.offsetParent ? a.offsetParent.getBoundingClientRect() : ra, t1);
  };

  placePath();
  fontsReady().then(placePath);
  const onResize = () => placePath();
  window.addEventListener('resize', onResize);
  if (window.ResizeObserver) {
    ro = new ResizeObserver(placePath);
    [top, bot].forEach((n) => { if (n) ro.observe(n); });
  }
  // la entrada se ve una vez por sesion: al volver a la home, todo ya pintado
  if (reduced() || yaVisto('hero')) {
    document.querySelectorAll('[data-eq-loadrule]').forEach((el) => { el.style.transition = 'none'; el.style.transform = 'scaleX(1)'; });
    const a = seg('h'), b = seg('v');
    if (a) a.style.clipPath = 'inset(0 0 0 100%)';
    if (b) b.style.clipPath = 'inset(' + (tailPct || 0) + '% 0 0 0)';
    settleType();
    window.dispatchEvent(new CustomEvent('eq:heroListo'));
  } else {
    ruleTimer = setTimeout(go, 620);
    // red de seguridad: el copy del hero nunca queda invisible
    typeGuard = setTimeout(() => { if (!typed) settleType(); }, 4200);
  }

  const batea = initBatea(root);

  return () => {
    clearTimeout(ruleTimer); clearTimeout(typeGuard); clearTimeout(heroAviso);
    window.removeEventListener('resize', onResize);
    if (ro) ro.disconnect();
    batea();
  };
});

/* ---- batea: fila de fundas apiladas ----------------------------------------
   Bisagra en el borde inferior: la funda del frente cae hacia el espectador
   con rotateX(-82deg) y la fila corre un lugar. */
function initBatea(root) {
  const wrap = root.querySelector('[data-eq-batea]');
  const stage = root.querySelector('[data-eq-batea-stage]');
  if (!wrap || !stage) return () => {};
  const sleeves = Array.from(stage.querySelectorAll('[data-eq-sleeve]'));
  const ticks = Array.from(root.querySelectorAll('[data-eq-tick]'));
  const ticksBox = root.querySelector('[data-eq-ticks]');
  const N = sleeves.length;
  if (!N) return () => {};
  let cur = 0;
  const cta = root.querySelector('[data-eq-hero-cta]');
  const timers = new Map();
  const shadow = 'rgba(31,30,31,0.20)';

  const depthStyle = (d) => d === 0
    ? { transform: 'rotateX(0deg) translateY(0px) scale(1)', opacity: '1', zIndex: '10',
        boxShadow: '0 2px 3px rgba(31,30,31,0.26), 0 16px 22px -12px ' + shadow + ', 0 36px 46px -26px rgba(31,30,31,0.36)' }
    : { transform: 'rotateX(2deg) translateY(' + (-d * 22) + 'px) scale(1)', opacity: '1', zIndex: String(10 - d), boxShadow: '0 -2px 4px rgba(31,30,31,0.30)' };
  const fallen = { transform: 'rotateX(-82deg) translateY(70px) scale(1.04)', opacity: '0', zIndex: '20', boxShadow: 'none' };
  const put = (el, st, animate) => {
    if (animate) { Object.assign(el.style, st); return; }
    const keep = el.style.transition;
    el.style.transition = 'none';
    Object.assign(el.style, st);
    void el.offsetHeight;
    el.style.transition = keep;
  };
  const paint = (prev, dir, animate) => {
    sleeves.forEach((el, i) => {
      const d = (i - cur + N) % N;
      clearTimeout(timers.get(el));
      if (animate && dir === 1 && i === prev) {
        put(el, fallen, true);
        timers.set(el, setTimeout(() => {
          put(el, { transform: 'rotateX(2deg) translateY(150px) scale(1)', opacity: '0', zIndex: '1', boxShadow: 'none' }, false);
          put(el, depthStyle((i - cur + N) % N), true);
        }, 560));
      } else if (animate && dir === -1 && i === cur) {
        put(el, fallen, false);
        put(el, depthStyle(0), true);
      } else {
        put(el, depthStyle(d), animate);
      }
    });
    ticks.forEach((b, i) => b.classList.toggle('is-on', i === cur));
    // el boton lleva a la ficha del disco que esta al frente
    if (cta) cta.href = sleeves[cur].dataset.eqHref || cta.dataset.eqBase || cta.href;
  };
  const goTo = (i, dir) => {
    const n = ((i % N) + N) % N;
    if (n === cur) return;
    const prev = cur;
    cur = n;
    paint(prev, dir, true);
  };

  paint(0, 0, false);
  const onPrev = () => goTo(cur - 1, -1);
  const onNext = () => goTo(cur + 1, 1);
  root.querySelector('[data-eq-prev]')?.addEventListener('click', onPrev);
  root.querySelector('[data-eq-next]')?.addEventListener('click', onNext);
  ticks.forEach((b) => b.addEventListener('click', () => { const i = Number(b.dataset.eqTick); goTo(i, i > cur ? 1 : -1); }));
  const onEnter = () => ticksBox && ticksBox.classList.add('is-awake');
  const onLeave = () => ticksBox && ticksBox.classList.remove('is-awake');
  wrap.addEventListener('pointerenter', onEnter);
  wrap.addEventListener('pointerleave', onLeave);
  const onKey = (e) => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); onNext(); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); onPrev(); }
  };
  stage.addEventListener('keydown', onKey);
  // con el cursor sobre la batea, la rueda pasa las portadas; despues de una
  // vuelta completa suelta el scroll para no dejar la pagina trabada
  let wheelAt = 0, wheelAcc = 0, wheelSteps = 0, wheelStepAt = 0;
  const onWheel = (e) => {
    const now = performance.now();
    if (now - wheelAt > 460) { wheelAcc = 0; wheelSteps = 0; }
    wheelAt = now;
    if (wheelSteps >= N) return;
    e.preventDefault();
    wheelAcc += e.deltaY;
    if (now - wheelStepAt < 360) return;
    if (Math.abs(wheelAcc) < 42) return;
    const dir = wheelAcc > 0 ? 1 : -1;
    wheelAcc = 0; wheelStepAt = now; wheelSteps++;
    goTo(cur + dir, dir);
  };
  stage.addEventListener('wheel', onWheel, { passive: false });
  let arrastro = false;
  const onDown = (e) => {
    const y0 = e.clientY;
    arrastro = false;
    stage.classList.add('is-grabbing');
    const up = (ev) => {
      window.removeEventListener('pointerup', up);
      stage.classList.remove('is-grabbing');
      const dy = ev.clientY - y0;
      if (Math.abs(dy) < 36) return;
      arrastro = true;
      goTo(cur + (dy > 0 ? 1 : -1), dy > 0 ? 1 : -1);
    };
    window.addEventListener('pointerup', up);
  };
  stage.addEventListener('pointerdown', onDown);
  // click en la batea = la ficha del disco del frente (aunque se toque el borde
  // de una funda de atras); un arrastre no navega
  const onClick = (e) => {
    e.preventDefault();
    if (arrastro) { arrastro = false; return; }
    const h = sleeves[cur].dataset.eqHref;
    if (!h) return;
    if (e.metaKey || e.ctrlKey) window.open(h, '_blank');
    else location.href = h;
  };
  stage.addEventListener('click', onClick);

  return () => {
    timers.forEach((t) => clearTimeout(t));
    stage.removeEventListener('wheel', onWheel);
    stage.removeEventListener('keydown', onKey);
    stage.removeEventListener('pointerdown', onDown);
    stage.removeEventListener('click', onClick);
    wrap.removeEventListener('pointerenter', onEnter);
    wrap.removeEventListener('pointerleave', onLeave);
  };
}
